/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_C1 as C1,
  rec_CapturarFirma as CapturarFirma,
  rec_CapturarFoto as CapturarFoto,
  rec_Componente_Q1_81_49 as Componente_Q1_81_49,
  rec_Componente_RDolar_82_36 as Componente_RDolar_82_36,
  rec_DetalleActa as DetalleActa,
  rec_EstadoError as EstadoError,
  rec_F1 as F1,
  rec_Fo as Fo,
  rec_Go as Go,
  rec_I1 as I1,
  rec_J1 as J1,
  rec_JSXRuntime as JSXRuntime,
  rec_PreguntaActa as PreguntaActa,
  rec_React as React,
  rec_S1 as S1,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_T1 as T1,
  rec_Za as Za,
  rec__1 as _1,
  rec__r as _r,
  rec_api as api,
  rec_b1 as b1,
  rec_c1 as c1,
  rec_es as es,
  rec_f1 as f1,
  rec_g1 as g1,
  rec_gr as gr,
  rec_kr as kr,
  rec_p1 as p1,
  rec_pS as pS,
  rec_w1 as w1,
  rec_y1 as y1,
  rec_z$ as z$,
  rec_z1 as z1,
} from "../../runtime/index.jsx";
export function FormularioActa({ inicial: e, onSalir: t }) {
  let n = (0, React.useMemo)(() => {
      let t = f1(e.plantilla?.cabecera, e.respuestas),
        n = p1(e.plantilla?.cabecera, t.datos, e.fundoNombre, e.concesionariaNombre);
      return {
        datos: n.datos,
        cambio: t.cambio || n.cambio,
      };
    }, [e]),
    [r] = (0, React.useState)(() => (e.editable ? C1(e.id, e.revision) : null)),
    [i, a] = (0, React.useState)(e),
    [o, s] = (0, React.useState)(r ?? n.datos),
    [c, l] = (0, React.useState)(0),
    [u, f] = (0, React.useState)(`adelante`),
    [p, m] = (0, React.useState)(!1),
    [h, g] = (0, React.useState)(``),
    [_, v] = (0, React.useState)(!1),
    [y, b] = (0, React.useState)(e.editable && (n.cambio || !!r)),
    x = Go(),
    { confirmar: S } = Fo(),
    C = (0, React.useRef)(null),
    w = i.plantilla,
    T = (0, React.useMemo)(() => c1(w.items), [w.items]),
    E = [
      `Datos de la inspección`,
      ...T.map((e) => e.nombre),
      `Evidencia y revisión`,
      `Firmas y cierre`,
    ],
    D = T.length + 1,
    O = D + 1,
    k = (0, React.useMemo)(() => {
      let e = {};
      return (
        T.forEach((t, n) =>
          t.items.forEach((t) => {
            e[t.id] = n + 1;
          }),
        ),
        e
      );
    }, [T]);
  (0, React.useEffect)(() => {
    if (!y) return;
    function e(e) {
      (e.preventDefault(), (e.returnValue = ``));
    }
    return (
      window.addEventListener(`beforeunload`, e),
      () => window.removeEventListener(`beforeunload`, e)
    );
  }, [y]);
  let [A, j] = (0, React.useState)(!1),
    [M, N] = (0, React.useState)(`foto:general`),
    P = g1(w.items, o),
    F = Object.fromEntries(P.map((e) => [e.id, e.faltan]));
  function I(e) {
    (s(e), b(!0), g(``), S1(i.id, i.revision, e));
  }
  function L(e, t) {
    I({
      ...o,
      cabecera: {
        ...o.cabecera,
        [e]: t,
      },
    });
  }
  function R(e, t, n) {
    I({
      ...o,
      items: {
        ...o.items,
        [e]: {
          ...o.items?.[e],
          [t]: n,
        },
      },
    });
  }
  async function z() {
    let e = await api(`/inspecciones/${i.id}`, {
      method: `PUT`,
      body: JSON.stringify({
        revision: i.revision,
        respuestas: o,
      }),
    });
    return (a(e), b(!1), w1(i.id), e);
  }
  let ee = (0, React.useRef)(z);
  ((0, React.useEffect)(() => {
    ee.current = z;
  }),
    (0, React.useEffect)(() => {
      if (!y || !i.editable) return;
      let e = () => {
        ee.current()
          .then(() => x.ok(`Lo contestado sin señal ya se guardó`))
          .catch(() => {});
      };
      return (
        window.addEventListener(`online`, e),
        () => window.removeEventListener(`online`, e)
      );
    }, [y, i.editable, x]));
  async function te(e) {
    (g(``), v(!0));
    try {
      await e();
    } catch (e) {
      (g(e.message), e?.status !== 400 && x.error(e.message));
    } finally {
      v(!1);
    }
  }
  function B(e = P) {
    e.length &&
      (j(!0),
      f(`atras`),
      l(k[e[0].id] ?? 1),
      setTimeout(
        () =>
          document.getElementById(`punto-${e[0].id}`)?.scrollIntoView?.({
            behavior: `smooth`,
            block: `center`,
          }),
        350,
      ));
  }
  async function V(e) {
    if (e === O && P.length) {
      B();
      return;
    }
    await te(async () => {
      if (y)
        try {
          await z();
        } catch (t) {
          if (t?.status !== 0 || e === O) throw t;
          x.info(
            `Sin señal: lo contestado quedó en el teléfono y se guarda al volver la señal`,
          );
        }
      (e === O &&
        (await api(`/inspecciones/${i.id}/revisar`, {
          method: `POST`,
        })),
        f(e < c ? `atras` : `adelante`),
        l(e),
        C.current?.closest(`main`)?.scrollTo?.({
          top: 0,
          behavior: `instant`,
        }));
    });
  }
  async function H(e, t, n = !1) {
    await te(async () => {
      let r = y ? await z() : i,
        o = new FormData();
      (o.append(`campo`, e),
        o.append(`revision`, String(r.revision)),
        o.append(`archivo`, n ? t : await z$(t)));
      let s = await Za(`/inspecciones/${i.id}/archivos`, o, {
        topeMs: 6e4,
      });
      (a(s), x.ok(n ? `Firma guardada` : `Foto guardada`));
    });
  }
  async function ne() {
    await te(async () => {
      if (y)
        throw (
          await z(),
          Error(
            `Los datos cambiaron. Revisa y vuelve a guardar las firmas antes de cerrar.`,
          )
        );
      if (
        !(await S({
          titulo: `Cerrar acta`,
          mensaje: `Las respuestas y firmas quedarán como constancia y ya no podrán editarse.`,
          confirmarTexto: `Firmar y cerrar`,
        }))
      )
        return;
      let e = await api(`/inspecciones/${i.id}/cerrar`, {
        method: `POST`,
        body: JSON.stringify({
          revision: i.revision,
          respuestas: o,
        }),
      });
      (a(e), m(!0), es(`exito`));
      try {
        navigator.vibrate?.([30, 40, 30]);
      } catch {}
    });
  }
  let re = w.items.length || 1,
    ie = _1(w.items, o),
    U = Math.round((ie * 100) / re);
  async function ae() {
    if (!i.editable) {
      t();
      return;
    }
    (await S({
      titulo: `¿Salir sin terminar?`,
      mensaje: `Llevás ${U}% del acta. Si salís, lo que contestaste no se guarda.`,
      confirmarTexto: `Salir sin guardar`,
      cancelarTexto: `Seguir con el acta`,
      peligro: !0,
    })) &&
      (await te(async () => {
        (await api(`/inspecciones/${i.id}/abandonar`, {
          method: `POST`,
          body: JSON.stringify({
            respuestas: o,
            paso: c,
            pasoNombre: E[c],
          }),
        }),
          w1(i.id),
          b(!1),
          x.info(`Acta descartada`),
          t());
      }));
  }
  let oe = c > 0 && c < D ? T[c - 1] : null,
    se = oe && _1(oe.items, o) === oe.items.length,
    ce =
      c === 0 ? J1.datos : oe ? J1.seccion : c === D ? J1.evidencia : J1.firmas,
    le = c === 0 ? `📝` : oe ? y1(oe.nombre) : c === D ? `📸` : `✍️`;
  if (p) {
    let e = w.items.filter((e) => z1(e, o.items?.[e.id]?.valor)).length;
    return (
      <div
        className={`mx-auto flex max-w-md flex-col items-center gap-4 py-10 text-center animar-entrada`}
        children={[
          <Componente_RDolar_82_36 />,
          <p
            className={`text-lg font-semibold text-(--text-h)`}
            children={`¡Acta firmada! 🎉`}
          />,
          <p
            className={`text-sm text-(--text)`}
            children={
              e === 0
                ? `Todo en regla. Gracias por revisarlo con cuidado.`
                : `${e === 1 ? `Quedó 1 punto` : `Quedaron ${e} puntos`} por levantar: ya le avisamos al área.`
            }
          />,
          <div
            className={`flex w-full flex-col gap-2 sm:flex-row`}
            children={[
              <AccionAsync
                className={`min-h-12 flex-1`}
                onClick={t}
                children={`Volver a las actas`}
              />,
              <AccionAsync
                variante={`secundario`}
                className={`min-h-12 flex-1`}
                onClick={() => m(!1)}
                children={`Ver el acta`}
              />,
            ]}
          />,
        ]}
      />
    );
  }
  return (
    <div
      className={`space-y-3`}
      children={[
        <AccionAsync
          variante={`texto`}
          icono={gr}
          className={`min-h-11`}
          disabled={_}
          onClick={ae}
          children={i.editable ? `Salir del acta` : `Volver a las actas`}
        />,
        <div
          ref={C}
          children={[
            <h1
              className={`text-lg font-semibold text-(--text-h) !m-0`}
              children={[i.nombre, ` · #`, i.id]}
            />,
            <p
              className={`mt-1 text-xs text-(--text)`}
              children={[
                i.unidadNombre,
                i.fundoNombre && `📍 ${i.fundoNombre}`,
                i.concesionariaNombre && `🏢 ${i.concesionariaNombre}`,
                i.inspector,
              ]
                .filter(Boolean)
                .join(` · `)}
            />,
          ]}
        />,
        !i.editable && <EstadoError mensaje={h} />,
        (i.arrastradas ?? []).length > 0 && (
          <div
            className={`flex flex-col gap-1 rounded-2xl border border-(--error-border) bg-(--error-bg) p-3 text-sm`}
            children={[
              <p
                className={`font-medium text-(--text-h)`}
                children={
                  i.editable
                    ? `Vuelven en esta acta ${i.arrastradas.length === 1 ? `1 observación rechazada` : `${i.arrastradas.length} observaciones rechazadas`} de ${i.concesionariaNombre}. Al cerrarla quedan otra vez por levantar.`
                    : `Volvieron en esta acta: ${i.arrastradas.length === 1 ? `1 observación rechazada` : `${i.arrastradas.length} observaciones rechazadas`} antes.`
                }
              />,
              <ul
                className={`flex flex-col gap-0.5 text-xs text-(--text)`}
                children={i.arrastradas.map((x) => (
                  <li key={x.id} children={[<strong className={`text-(--text-h)`} children={x.etiqueta} />, x.motivoRechazo ? ` — rechazada: ${x.motivoRechazo}` : ``]} />
                ))}
              />,
            ]}
          />
        ),
        i.editable && i.seBorraEl && (
          <div
            role={`alert`}
            className={`animar-entrada flex flex-col gap-2 rounded-2xl border border-(--warning-border) bg-(--warning-bg) p-3 text-sm sm:flex-row sm:items-center sm:justify-between`}
            children={[
              <p
                className={`text-(--text-h)`}
                children={[
                  `⏳ Esta acta se borra el `,
                  <strong children={pS(i.seBorraEl)} />,
                  ` si no la terminas, con sus fotos.`,
                ]}
              />,
              i.puedeProrrogar && (
                <AccionAsync
                  variante={`secundario`}
                  className={`min-h-11 shrink-0`}
                  disabled={_}
                  onClick={() =>
                    te(async () => {
                      (a(
                        await api(`/inspecciones/${i.id}/prorrogar`, {
                          method: `POST`,
                        }),
                      ),
                        x.ok(`Tienes 24 horas más para terminarla`));
                    })
                  }
                  children={`La voy a terminar`}
                />
              ),
            ]}
          />
        ),
        i.editable ? (
          <JSXRuntime.Fragment
            children={[
              <div
                className={`space-y-1`}
                children={[
                  <div
                    className={`flex items-center justify-between text-xs`}
                    children={[
                      <span
                        className={`font-medium text-(--text-h)`}
                        children={b1(U)}
                      />,
                      <span
                        className={`tabular-nums text-(--text)`}
                        children={[U, `% · `, ie, ` de `, w.items.length]}
                      />,
                    ]}
                  />,
                  <div
                    role={`progressbar`}
                    aria-label={`Respuestas completadas`}
                    aria-valuemin={0}
                    aria-valuemax={w.items.length || 1}
                    aria-valuenow={ie}
                    className={`h-2.5 overflow-hidden rounded-full bg-(--border)`}
                    children={
                      <div
                        className={`h-full rounded-full bg-(--accent) transition-all duration-500 ease-(--curva)`}
                        style={{
                          width: `${U}%`,
                        }}
                      />
                    }
                  />,
                ]}
              />,
              <nav
                aria-label={`Pasos del acta`}
                className={`-mx-1 flex gap-2 overflow-x-auto px-1 pb-1`}
                children={E.map((e, t) => {
                  let n = t > 0 && t < D ? T[t - 1] : null,
                    r = n ? _1(n.items, o) === n.items.length : !1,
                    i = t === c;
                  return (
                    <button
                      key={e}
                      type={`button`}
                      disabled={_}
                      onClick={() => V(t)}
                      aria-current={i ? `step` : void 0}
                      aria-label={`Ir a ${e}`}
                      className={`flex min-h-11 shrink-0 items-center gap-1.5 rounded-full border px-3 text-xs transition active:scale-[0.95] ${i ? `animar-latido border-(--accent) bg-(--accent-bg) font-semibold text-(--text-h)` : r ? `border-(--success) text-(--text-h)` : `border-(--border) text-(--text)`}`}
                      children={[
                        <span
                          aria-hidden={`true`}
                          children={
                            t === 0
                              ? `📝`
                              : n
                                ? y1(n.nombre)
                                : t === D
                                  ? `📸`
                                  : `✍️`
                          }
                        />,
                        <span className={`max-w-40 truncate`} children={e} />,
                        r &&
                          (0, JSXRuntime.jsx)(kr, {
                            className: `animar-pop h-3.5 w-3.5 text-(--success)`,
                            strokeWidth: 3,
                            "aria-hidden": `true`,
                          }),
                      ]}
                    />
                  );
                })}
              />,
              <fieldset
                disabled={_}
                className={`min-w-0 space-y-4`}
                children={
                  <section
                    key={c}
                    className={`${I1} ${u === `adelante` ? `animar-desde-derecha` : `animar-desde-izquierda`} space-y-4`}
                    children={[
                      <div
                        className={`flex flex-wrap items-start justify-between gap-2`}
                        children={[
                          <div
                            className={`flex min-w-0 items-start gap-3`}
                            children={[
                              <span
                                className={`animar-rebote text-3xl`}
                                aria-hidden={`true`}
                                children={le}
                              />,
                              <div
                                className={`min-w-0`}
                                children={[
                                  <h2
                                    className={`text-base font-semibold text-(--text-h) !m-0`}
                                    children={E[c]}
                                  />,
                                  <p
                                    className={`text-xs text-(--text)`}
                                    children={ce}
                                  />,
                                ]}
                              />,
                            ]}
                          />,
                          oe?.items.some(
                            (e) =>
                              e.tipo === `UNICA` &&
                              e.negativos?.length &&
                              !o.items?.[e.id]?.valor,
                          ) && (
                            <AccionAsync
                              variante={`secundario`}
                              icono={kr}
                              className={`min-h-11`}
                              onClick={() => {
                                I({
                                  ...o,
                                  items: T1(oe.items, o.items),
                                });
                                try {
                                  navigator.vibrate?.(20);
                                } catch {}
                              }}
                              children={`Todo cumple`}
                            />
                          ),
                          se && !(A && oe.items.some((e) => F[e.id])) && (
                            <span
                              className={`animar-pop rounded-full bg-(--success)/15 px-3 py-1 text-xs font-semibold text-(--success)`}
                              children={`✅ Sección lista`}
                            />
                          ),
                        ]}
                      />,
                      c === 0 && (
                        <div
                          className={`grid gap-3 sm:grid-cols-2`}
                          children={w.cabecera.map((e) =>
                            (e.id === `ubicacion` && i.fundoNombre) || (e.id === `concesionaria` && i.concesionariaNombre) ? (
                              <div
                                key={e.id}
                                className={`space-y-1`}
                                children={[
                                  <span
                                    className={`block text-sm text-(--text-h)`}
                                    children={e.etiqueta}
                                  />,
                                  <p
                                    className={`flex min-h-11 items-center gap-2 rounded-xl border border-(--border) bg-(--panel) px-3 text-base text-(--text-h)`}
                                    children={[
                                      e.id === `concesionaria` ? `🏢 ` : `📍 `,
                                      o.cabecera?.[e.id] || (e.id === `concesionaria` ? i.concesionariaNombre : i.fundoNombre),
                                    ]}
                                  />,
                                ]}
                              />
                            ) : (
                              <PreguntaActa
                                key={e.id}
                                campo={e}
                                valor={o.cabecera?.[e.id]}
                                onChange={(t) => L(e.id, t)}
                              />
                            ),
                          )}
                        />
                      ),
                      oe && (
                        <div
                          className={`animar-cascada divide-y divide-(--border)`}
                          children={oe.items.map((e) => (
                            <div
                              key={e.id}
                              role={`group`}
                              aria-labelledby={`punto-${e.id}`}
                              className={`grid items-center gap-x-3 py-2 first:pt-0 last:pb-0 sm:grid-cols-[minmax(0,1fr)_auto]`}
                              children={[
                                <div
                                  className={`grid min-w-0 items-center gap-2 sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]`}
                                  children={[
                                    <p
                                      id={`punto-${e.id}`}
                                      className={`text-sm font-medium text-(--text-h)`}
                                      children={[
                                        w.items.indexOf(e) + 1,
                                        `. `,
                                        e.etiqueta,
                                        e.obligatorio ? ` *` : ``,
                                      ]}
                                    />,
                                    <div
                                      className={`min-w-0 space-y-2`}
                                      children={[
                                        <PreguntaActa
                                          campo={e}
                                          valor={o.items?.[e.id]?.valor}
                                          onChange={(t) => R(e.id, `valor`, t)}
                                          sinTitulo={!0}
                                        />,
                                        e.vigencia &&
                                          o.items?.[e.id]?.valor &&
                                          o.items[e.id].valor !== `N.A.` && (
                                            <div
                                              className={`animar-entrada space-y-1 text-xs text-(--text)`}
                                              children={[
                                                <p
                                                  children={`Vigente hasta`}
                                                />,
                                                <SelectorFecha
                                                  className={`[&>button]:min-h-11`}
                                                  value={
                                                    o.items?.[e.id]?.vigencia ||
                                                    ``
                                                  }
                                                  onChange={(t) =>
                                                    R(e.id, `vigencia`, t)
                                                  }
                                                />,
                                              ]}
                                            />
                                          ),
                                      ]}
                                    />,
                                  ]}
                                />,
                                z1(e, o.items?.[e.id]?.valor) &&
                                  (() => {
                                    let t = A ? (F[e.id] ?? []) : [],
                                      n = (e) =>
                                        t.includes(e)
                                          ? ` !border-(--error) ring-1 ring-(--error)`
                                          : ``;
                                    return (
                                      <div
                                        className={`animar-desde-derecha order-last col-span-full space-y-3 rounded-xl border p-3 ${t.length ? `border-(--error) bg-(--error-bg)` : `border-(--warning-border) bg-(--warning-bg)`}`}
                                        children={[
                                          <div
                                            className={`flex items-center gap-2`}
                                            children={[
                                              <span
                                                aria-hidden={`true`}
                                                children={`⚠️`}
                                              />,
                                              <p
                                                className={`text-sm font-medium text-(--text-h)`}
                                                children={`Por levantar`}
                                              />,
                                            ]}
                                          />,
                                          t.length > 0 ? (
                                            <p
                                              role={`alert`}
                                              className={`text-xs font-medium text-(--error)`}
                                              children={`Falta completar lo marcado en rojo.`}
                                            />
                                          ) : (
                                            <p
                                              className={`text-xs text-(--text)`}
                                              children={`Contá qué viste, qué hay que hacer, quién lo levanta y para cuándo.`}
                                            />
                                          ),
                                          <label
                                            className={`block space-y-1 text-sm`}
                                            children={[
                                              `Observación detectada`,
                                              <textarea
                                                className={`${F1}${n(`observacion`)}`}
                                                rows={2}
                                                maxLength={1e3}
                                                value={
                                                  o.items?.[e.id]
                                                    ?.observacion || ``
                                                }
                                                onChange={(t) =>
                                                  R(
                                                    e.id,
                                                    `observacion`,
                                                    t.target.value,
                                                  )
                                                }
                                              />,
                                            ]}
                                          />,
                                          <label
                                            className={`block space-y-1 text-sm`}
                                            children={[
                                              `Acción correctiva`,
                                              <textarea
                                                className={`${F1}${n(`accion`)}`}
                                                maxLength={1e3}
                                                value={
                                                  o.items?.[e.id]?.accion || ``
                                                }
                                                onChange={(t) =>
                                                  R(
                                                    e.id,
                                                    `accion`,
                                                    t.target.value,
                                                  )
                                                }
                                              />,
                                            ]}
                                          />,
                                          <label
                                            className={`block space-y-1 text-sm`}
                                            children={[
                                              `Responsable`,
                                              <input
                                                className={`${F1}${n(`responsable`)}`}
                                                maxLength={150}
                                                value={
                                                  o.items?.[e.id]
                                                    ?.responsable || ``
                                                }
                                                onChange={(t) =>
                                                  R(
                                                    e.id,
                                                    `responsable`,
                                                    t.target.value.toUpperCase(),
                                                  )
                                                }
                                              />,
                                            ]}
                                          />,
                                          <div
                                            className={`space-y-1 text-sm`}
                                            children={[
                                              <p
                                                children={`Fecha de levantamiento`}
                                              />,
                                              <p
                                                className={`text-xs text-(--text)`}
                                                children={`Opcional. Si la dejas vacía: crítica 24 h, alta 3 días, media 7, baja 15.`}
                                              />,
                                              <SelectorFecha
                                                className={`[&>button]:min-h-11${t.includes(`fechaCompromiso`) ? ` [&>button]:!border-(--error) [&>button]:ring-1 [&>button]:ring-(--error)` : ``}`}
                                                value={
                                                  o.items?.[e.id]
                                                    ?.fechaCompromiso || ``
                                                }
                                                onChange={(t) =>
                                                  R(e.id, `fechaCompromiso`, t)
                                                }
                                              />,
                                            ]}
                                          />,
                                        ]}
                                      />
                                    );
                                  })(),
                                <details
                                  open={
                                    !!(
                                      o.items?.[e.id]?.observacion ||
                                      i.archivos.some(
                                        (t) => t.campo === `foto:${e.id}`,
                                      )
                                    )
                                  }
                                  className={`mt-1 text-sm open:col-span-full sm:mt-0`}
                                  children={[
                                    <summary
                                      className={`min-h-11 cursor-pointer content-center text-xs text-(--accent-texto) focus-visible:ring-2 focus-visible:ring-(--accent-border)`}
                                      children={[
                                        `Observación y fotos`,
                                        o.items?.[e.id]?.observacion
                                          ? ` · Con observación`
                                          : ``,
                                        i.archivos.some(
                                          (t) => t.campo === `foto:${e.id}`,
                                        )
                                          ? ` · Con fotos`
                                          : ``,
                                      ]}
                                    />,
                                    <div
                                      className={`animar-entrada grid gap-3 pb-2 sm:grid-cols-2`}
                                      children={[
                                        !z1(e, o.items?.[e.id]?.valor) && (
                                          <label
                                            className={`block space-y-1 text-sm`}
                                            children={[
                                              `Observación`,
                                              <textarea
                                                className={F1}
                                                rows={2}
                                                maxLength={1e3}
                                                value={
                                                  o.items?.[e.id]
                                                    ?.observacion || ``
                                                }
                                                onChange={(t) =>
                                                  R(
                                                    e.id,
                                                    `observacion`,
                                                    t.target.value,
                                                  )
                                                }
                                              />,
                                            ]}
                                          />
                                        ),
                                        <div
                                          className={`space-y-2`}
                                          children={[
                                            <CapturarFoto
                                              disabled={_}
                                              onFile={(t) =>
                                                H(`foto:${e.id}`, t)
                                              }
                                            />,
                                            <Componente_Q1_81_49
                                              acta={i}
                                              campo={`foto:${e.id}`}
                                            />,
                                          ]}
                                        />,
                                      ]}
                                    />,
                                  ]}
                                />,
                              ]}
                            />
                          ))}
                        />
                      ),
                      c === D && (
                        <JSXRuntime.Fragment
                          children={[
                            <label
                              className={`flex flex-col gap-1 text-sm text-(--text-h)`}
                              children={[
                                `¿De qué es la foto?`,
                                <SelectorMultiple
                                  className={`[&>button]:min-h-11`}
                                  placeholder={`📸 Vista general del lugar`}
                                  value={M === `foto:general` ? `` : M}
                                  onChange={(e) => N(e || `foto:general`)}
                                  opciones={[
                                    ...w.items
                                      .filter((e) =>
                                        z1(e, o.items?.[e.id]?.valor),
                                      )
                                      .map((e) => {
                                        let t = o.items?.[e.id]?.valor,
                                          n = Array.isArray(t)
                                            ? t.join(`, `)
                                            : t;
                                        return {
                                          value: `foto:${e.id}`,
                                          label: `⚠️ ${w.items.indexOf(e) + 1}. ${e.etiqueta} — ${n}`,
                                        };
                                      }),
                                    ...w.items
                                      .filter(
                                        (e) => !z1(e, o.items?.[e.id]?.valor),
                                      )
                                      .map((e) => ({
                                        value: `foto:${e.id}`,
                                        label: `${w.items.indexOf(e) + 1}. ${e.etiqueta}`,
                                      })),
                                  ]}
                                />,
                              ]}
                            />,
                            <CapturarFoto
                              disabled={_}
                              onFile={(e) => H(M, e)}
                            />,
                            w.fotoObligatoria && (
                              <p
                                className={`text-xs text-(--text)`}
                                children={`Agrega al menos una foto para cerrar esta inspección.`}
                              />
                            ),
                            <DetalleActa
                              acta={i}
                              datos={o}
                              onEditar={V}
                              pasoDelItem={k}
                            />,
                          ]}
                        />
                      ),
                      c === O && (
                        <JSXRuntime.Fragment
                          children={[
                            <p
                              className={`text-sm text-(--text)`}
                              children={`Revisa las respuestas antes de firmar. Cambiar los datos requiere volver a firmar. Al cerrar, el acta queda como constancia de la inspección.`}
                            />,
                            w.firmas.map((e, t) => (
                              <div
                                key={e}
                                className={`space-y-3 border-t border-(--border) pt-4`}
                                children={[
                                  <label
                                    className={`block space-y-1 text-sm`}
                                    children={[
                                      `Nombre · `,
                                      e,
                                      <input
                                        className={F1}
                                        maxLength={150}
                                        value={o.firmantes?.[t] || ``}
                                        onChange={(e) => {
                                          let n = [...(o.firmantes || [])];
                                          ((n[t] =
                                            e.target.value.toUpperCase()),
                                            I({
                                              ...o,
                                              firmantes: n,
                                            }));
                                        }}
                                      />,
                                    ]}
                                  />,
                                  i.archivos.some(
                                    (e) => e.campo === `firma:${t}`,
                                  ) && !y ? (
                                    <JSXRuntime.Fragment
                                      children={[
                                        <p
                                          className={`animar-pop flex items-center gap-2 text-sm text-(--success)`}
                                          children={[
                                            (0, JSXRuntime.jsx)(kr, {
                                              className: `h-4 w-4`,
                                            }),
                                            `Firma guardada`,
                                          ]}
                                        />,
                                        <Componente_Q1_81_49
                                          acta={i}
                                          campo={`firma:${t}`}
                                        />,
                                      ]}
                                    />
                                  ) : (
                                    <CapturarFirma
                                      titulo={e}
                                      disabled={
                                        _ ||
                                        !w.firmas.every((e, t) =>
                                          o.firmantes?.[t]?.trim(),
                                        )
                                      }
                                      onGuardar={(e) => H(`firma:${t}`, e, !0)}
                                    />
                                  ),
                                ]}
                              />
                            )),
                            w.firmaAcciones &&
                              w.items
                                .filter((e) => z1(e, o.items?.[e.id]?.valor))
                                .map((e) => (
                                  <details
                                    key={e.id}
                                    className={`border-t border-(--border) pt-3`}
                                    children={[
                                      <summary
                                        className={`min-h-11 cursor-pointer text-sm`}
                                        children={[
                                          `Firma de la acción correctiva · `,
                                          e.etiqueta,
                                        ]}
                                      />,
                                      <p
                                        className={`mb-3 text-xs text-(--text)`}
                                        children={`Opcional: constancia del responsable de la acción.`}
                                      />,
                                      i.archivos.some(
                                        (t) =>
                                          t.campo === `firma-accion:${e.id}`,
                                      ) && !y ? (
                                        <Componente_Q1_81_49
                                          acta={i}
                                          campo={`firma-accion:${e.id}`}
                                        />
                                      ) : (
                                        <CapturarFirma
                                          titulo={
                                            o.items?.[e.id]?.responsable ||
                                            `Responsable de la acción`
                                          }
                                          disabled={_}
                                          onGuardar={(t) =>
                                            H(`firma-accion:${e.id}`, t, !0)
                                          }
                                        />
                                      ),
                                    ]}
                                  />
                                )),
                          ]}
                        />
                      ),
                    ]}
                  />
                }
              />,
              A &&
                (P.length > 0 ? (
                  <div
                    className={`animar-pop flex flex-wrap items-center justify-between gap-2 rounded-xl border border-(--error) bg-(--error-bg) px-3 py-2 text-sm`}
                    children={[
                      <span
                        className={`text-(--text-h)`}
                        children={[
                          P.length === 1
                            ? `Falta completar 1 punto por levantar`
                            : `Faltan completar ${P.length} puntos por levantar`,
                          `: `,
                          P[0].etiqueta,
                          `.`,
                        ]}
                      />,
                      <AccionAsync
                        variante={`texto`}
                        className={`min-h-11`}
                        onClick={() => B()}
                        children={`Ir al punto`}
                      />,
                    ]}
                  />
                ) : (
                  <p
                    className={`animar-pop rounded-xl bg-(--success)/15 px-3 py-2 text-sm font-medium text-(--success)`}
                    children={`✅ Todo completo: ya podés seguir a las firmas.`}
                  />
                )),
              h && (
                <p
                  role={`alert`}
                  className={`text-sm text-(--error)`}
                  children={h}
                />
              ),
              <p
                className={`text-xs text-(--text)`}
                children={[
                  y
                    ? `Lo contestado está en el teléfono; se guarda al avanzar.`
                    : `Se guarda al avanzar.`,
                  ` Las fotos y las firmas necesitan señal.`,
                ]}
              />,
              <div
                className={`sticky bottom-0 flex flex-wrap items-center justify-between gap-2 border-t border-(--border) bg-(--bg) py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]`}
                children={[
                  <AccionAsync
                    variante={`secundario`}
                    className={`min-h-11`}
                    disabled={_ || c === 0}
                    icono={gr}
                    onClick={() => V(c - 1)}
                    children={`Atrás`}
                  />,
                  c < O ? (
                    <AccionAsync
                      className={`min-h-11 ${c === 0 || se || c === D ? `animar-latido` : ``}`}
                      disabled={_}
                      icono={_r}
                      onClick={() => V(c + 1)}
                      children={`Continuar`}
                    />
                  ) : (
                    <AccionAsync
                      className={`min-h-11 animar-latido`}
                      disabled={_}
                      onClick={ne}
                      children={`Cerrar acta`}
                    />
                  ),
                ]}
              />,
            ]}
          />
        ) : (
          <DetalleActa acta={i} datos={o} />
        ),
      ]}
    />
  );
}
